import { useEffect } from 'react';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { ROUTES } from '@constants/routes';
import { USER_TYPE } from '@constants/user.constants';
import { useAuthStore } from '@store';

function RequireAuth() {
  const location = useLocation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const user = useAuthStore((state) => state.user);
  const clearAuth = useAuthStore((state) => state.clearAuth);
  const isAdmin = user?.user_type === USER_TYPE.ADMIN;

  useEffect(() => {
    if (isAuthenticated && !isAdmin) {
      clearAuth();
    }
  }, [clearAuth, isAdmin, isAuthenticated]);

  if (!isAuthenticated || !isAdmin) {
    return <Navigate to={ROUTES.LOGIN} replace state={{ from: location }} />;
  }

  return <Outlet />;
}

export default RequireAuth;
